module.exports = __webpack_public_path__ + "assets/media/day12.cba0917e.mp3";